import { Fragment } from "react";
import classes from "./Stepper.module.scss";
import { clsx } from "clsx";

interface IProps {
  currentStep: number;
  stepsCount: number;
}

export default function HorizontalLabelPositionBelowStepper(props: IProps) {
  const { currentStep, stepsCount } = props;

  const steps = new Array<string>(stepsCount).fill("");

  return (
    <div className={classes.Stepper}>
      { steps.map((label, index) => (
        <Fragment key={index}>
          { index === currentStep ? (
            <div className={classes.PointContainer}>
              <div className={classes.Point}></div>
            </div>
          ) : (
            <div className={clsx(classes.Step, { [classes.StepIsActive]: index < currentStep })} />
          )}
        </Fragment>
      ))}
    </div>
  );
}
